import cx from 'classnames';
import { HTMLAttributes, PropsWithChildren } from 'react';
import styles from './OrganizationSubRowBlock.module.scss';

interface IProps extends PropsWithChildren, HTMLAttributes<HTMLDivElement> {
  className?: string;
}

const OrganizationSubRowBlock = ({ className, children, ...props }: IProps) => {
  return (
    <div className={cx(styles.block, className)} {...props}>
      {children}
    </div>
  );
};

export default OrganizationSubRowBlock;
